import PricingBreakdown from "./PricingBreakdown";
import { IoIosCheckbox } from "react-icons/io";

function PricingSectionReimbursed({ data }) {
  return (
    <div className="w-full border h-fit border-gray-200 rounded-xl overflow-hidden bg-white mt-4 p-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-gray-900">Refund</h2>
        <span className="bg-green-100 text-green-700 text-sm font-semibold px-3 py-1 rounded-md">
          Re-imbursed
        </span>
      </div>
      <div className="w-full mb-4 gap-2 flex flex-col">
        <div className="text-xs">Your Intraverse wallet has been credited.</div>
      </div>

      {/* Content */}
      <div className="bg-primary1/5 p-4 text-sm text-gray-700">
        {/* Per-passenger sections */}
        <PricingBreakdown data={data} />
      </div>
    </div>
  );
}

export default PricingSectionReimbursed;
